var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.label),expression:"label"}],staticClass:"error"},[_c('font-awesome-icon',{attrs:{"icon":"exclamation-circle"}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }